var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main"},[_c('router-view'),_c('footTab',{directives:[{name:"show",rawName:"v-show",value:(this.$route.meta.hasTab),expression:"this.$route.meta.hasTab"}]})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }